export default __webpack_public_path__ + "static/media/icon-big-monitoring-esim-88-px.9bfdea5b.svg";